export default __webpack_public_path__ + "static/media/glrc-course.culinary_essentials.5f8517b5.png";